// extracted by mini-css-extract-plugin
module.exports = {"total":"Total-Total-module--total--2fPRz"};